import React from 'react';
import { Box, Typography, Paper, Alert } from '@mui/material';

const SubscriptionFeatureForm = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Subscription Feature Form
        </Typography>
        <Alert severity="info">
          This form will be implemented to create and edit subscription features.
        </Alert>
      </Paper>
    </Box>
  );
};

export default SubscriptionFeatureForm;
